export default __webpack_public_path__ + "media/components/Pay/Index/Images/mc-eb3036a1152f616e004ddaa9f79970c2.svg";